import DcimServer from "@/api/dcim";

export default {

  namespaced: true,

  state: {
    items: [],
  },

  getters: {
    items(state) {
      return state.items;
    }
  },

  mutations: {
    setItems(state, items) {
      state.items = items;
    },
  },

  actions: {
    async load({commit}) {
      let items = [], equipmentTypeMemos = [];
      equipmentTypeMemos = await DcimServer.equipment.getEquipmentTypeMemos();
      for (let i = 0, len = equipmentTypeMemos.length; i < len; i++) {
        items.push({value: equipmentTypeMemos[i], label: equipmentTypeMemos[i]});
      }
      commit("setItems", items);
    },
  },

}